import { Link } from "react-router-dom";

const removeWhiteSpace = (string) => string.replace(/\s/g, '');
const removePunctuation = (string) => string.replace(/[.,#!$%^&*;:{}=\-_`~()]/g, '');
const addZeroes = (num) => {
  const dec = num.toString().split('.')[1];
  const len = dec && dec.length > 2 ? dec.length : 2;
  return Number(num).toFixed(len);
};

export default function Product(props){
  const productName = removeWhiteSpace(props.name);
  const cleanedProductName = removeWhiteSpace(removePunctuation(props.name));
  const imageExt = props.imageExt || 'jpg';
  const isSoldOut = props.supply !== undefined && props.supply <= 0;

  const productContent = (
    <>
      <div className="productImageWrapper" style={{ position: 'relative' }}>
        <img className="productImage" src={`images/${productName}.${imageExt}`} alt={productName} style={{ filter: isSoldOut ? 'grayscale(100%)' : 'none' }}></img>
        {isSoldOut && (
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#434343',
            color: 'white',
            padding: '10px 20px',
            borderRadius: '5px',
            fontWeight: 'bold',
            fontSize: '18px',
            zIndex: 10
          }}>
            SOLD OUT
          </div>
        )}
      </div>
      <h2 className="productTitle">{props.name}</h2>
      <p className="productPrice">£{addZeroes(props.price)}</p>
    </>
  );

  return(
    <div className="grid-item" style={{ position: 'relative', opacity: isSoldOut ? 0.6 : 1 }}>
      {isSoldOut ? (
        <div style={{ cursor: 'not-allowed' }}>
          {productContent}
        </div>
      ) : (
        <Link to={`../../${cleanedProductName}`}>
          {productContent}
        </Link>
      )}
    </div>
  );
}
